(function($, undefined) {
	'use strict';
	let desktopSlides;

	var init = function() {
		$('.titled-content__btns-settings-popup-content').on('click', '.titled-content__btn-settings-save-btn', saveBtnSettings);
		$('.titled-content__add-button-btn').click(addNewButton);
		$('.titled-content__btns-settings-popup-content').on('click', '.titled-content__remove-button-btn',removeButton);
	};

	function addNewButton() {
		var outerCtn = $(this).closest('.stool-shared-popup-content-ctn');
		var clone = outerCtn.find('.titled-content__btn-ctn.clone').clone();
		var ctn = outerCtn.find('.titled-content__btns-settings-popup-content');
		var index = ctn.children().length + 1;
		var key =  ctn.attr('data-key');

		updateLabel(key + ".total", index, $('html').attr('lang'), function() {}, false);

		clone.find('.index').html(index);
		clone.find('a').attr('data-id', key +'.'+ index);
		clone.find('.titled-content__btn-settings-save-btn').attr('data-key', key +'.'+ index);
		clone.find('.stool-component-settings-checkbox-ctn input').attr('name', key +'.'+ index + '.color');
		clone.removeClass('clone').removeAttr('style');
		ctn.append(clone);
	}

	function removeButton() {
		var t = $(this);
		var ctn = t.closest('.stool-shared-popup-content-ctn').find('.titled-content__btns-settings-popup-content');

		t.closest('.titled-content__btn-ctn').slideUp(function() {
			$(this).remove();
			updateLabel(ctn.attr('data-key') + ".total", ctn.children().length, $('html').attr('lang'), function() {}, false);
		});
	}
	
	function saveBtnSettings() {
		var fields = $(this).closest('.btn-form').find('form')[0].elements,
			data = {},
			lang = $('html').attr('lang'),
			list = ["type", "href", "target", "text", "query", "event", "custom"],
			successCd = list.length,
			key = $(this).attr('data-key');

		// code from shared tools.js
		for (var i = 0; i < fields.length; i++) {
			var inp = fields[i],
				name = inp.name,
				val = inp.value;

			if (inp.className.indexOf('edit-link-tab') !== -1) {
				if (inp.checked) {
					data[name] = val;
					data.href = val !== "" ? fields.namedItem(val).value : "";
					// el.setAttribute("data-" + name, val);
				}
			} else if (inp.type === "radio" || inp.type === "checkbox") {
				if (inp.checked) {
					data[name] = val;
					// el.setAttribute("data-" + name, val);
				} else{
					data[name] = false;
					// el.setAttribute("data-" + name, false);
				}

			} else{
				data[name] = val;
				// el.setAttribute("data-" + name, val);
				if (name === "page" && inp.selectedIndex > -1) data.tag = inp.options[inp.selectedIndex].getAttribute("data-tag");
			}
		}
		console.log(data);
		for (var j = 0; j < list.length; j++) {
			var it = list[j];
			updateLabel(key + "." + it, data[it], lang, _complete, false);
		}


		function _complete() {
			if (--successCd <= 0) {
				var a = $('a[data-id="'+key+'"]');
				if (a) {
					a.each(function() {
						var el = $(this)[0];
						el.href = data.type === "" ? "javascript:void(0);"
							   : (data.type === "page" ? data.tag : data.href)
								 + (data.type !== "internal" ? data.query : "");
						if (!el.children[0]) {
							el.innerHTML = data.text || el.getAttribute("data-text");
						}
						if (data.target === "") {
							el.removeAttribute("target");
							el.removeAttribute("rel");
						} else {
							el.target = data.target;
							el.rel = "noopener nofollow";
						}
						el.onclick = data.event === "" ? null
							: function(e) {
								e.preventDefault();
								eval(data.event);
						};
					});
				}
			}
		}
	}

	$(window).ready(function() {
		init();
	});
})(jQuery);
